import React, { Component } from 'react';
import './Login.css'
import authService from '../../../services/auth.service';
import VerifyPhone from '../verify-phone/VerifyPhone';
import userService from '../../../services/user.service';

declare var $;
declare var FB;
declare var AccountKit;
declare var fbq;


class Login extends Component {

  constructor(props) {
      super(props)
      this.state = {
        username: '',
        password: '',
        error: '',
        loginNum : false,
        user: [],
        loading: false
      };
     this.loginEmail = this.loginEmail.bind(this);
     this.setPassword = this.setPassword.bind(this)
     this.setEmail = this.setEmail.bind(this)
     this.loginFb = this.loginFb.bind(this)
     this.getFbUser = this.getFbUser.bind(this)
     this.openSignupForm = this.openSignupForm.bind(this);
     this.handleVerification = this.handleVerification.bind(this);

  }

  componentDidMount() {
    this.setState({
      loading: false
    })
  }

  async loginEmail() {
    fbq('trackCustom', 'LoginButton', {
       content_name: 'email'
     });
      this.setState({
        loading: true
      })
      let response = await authService.loginEmail(this.state)
       if(response.success) {
           response = response.data;
           localStorage.setItem('accessToken', response.token);
           fbq('trackCustom', 'Login', {
              status: 'success',
              content_name: 'email'
            });
           this.props.logued(true);
       } else {
         fbq('trackCustom', 'Login', {
            status: 'failed',
            content_name: 'email'
          });
         this.setState({
           error: (response.message_error).message,
           loading: false
         })

       }
  }

  async getToken(user) {

    let response = await authService.getToken(user)
     if(response.success) {
         response = response.data;
         localStorage.setItem('accessToken', response.token);
         fbq('trackCustom', 'Login', {
            status: 'success',
            content_name: 'sms'
          });
         this.props.logued(true);
     } else {
       fbq('trackCustom', 'Login', {
          status: 'failed',
          content_name: 'sms'
        });
       this.setState({
         error: (response.message_error).message,
         loading: false
       })

     }
  }


   async loginFb(data,accessToken) {
        let response = await authService.loginFb(data,accessToken)
        if(response.access_token) {
          localStorage.setItem('accessToken', response.access_token);
          fbq('trackCustom', 'Login', {
             status: 'success',
             content_name: 'facebook'
           });
          this.props.logued(true);
        } else {
          fbq('trackCustom', 'Login', {
             status: 'failed',
             content_name: 'facebook'
           });
        }
    }

  getFbUser() {
    this.setState({
      loading: true
    })
    fbq('trackCustom', 'LoginButton', {
       content_name: 'facebook'
     });

    FB.login((response) => {
        let accessToken = response.authResponse.accessToken
         FB.api('/me?fields=email,first_name, last_name, gender',  (response) => {
          this.loginFb(response, accessToken)
        });
    }, {scope: 'public_profile,email'});
  }

  setPassword(event) {
    this.setState({
      password: event.target.value
    })
  }

  setEmail(event) {
    this.setState({
      username: event.target.value
    })
  }

  openSignupForm() {
    fbq('trackCustom', 'LoginButton', {
       content_name: 'sms'
     });
    this.setState({
      loginNum: true
    })
  }

  async handleVerification(phone) {
    if(phone) {
     this.state.user.phone = phone
     let response = await userService.getUser(phone)
     if(response.users[0]) {
         this.getToken(response.users[0])
     } else {
       this.setState({
         createUserForm: true
       })
     }
    }
  }



  render() {
    return (
  <div>
    {  !this.state.loginNum  &&
        <div id="login" className="row  container animated fadeIn center">

        {this.state.loading  &&  <div className="progress">
              <div className="indeterminate"></div>
          </div> }
             <a className={"btn fb waves-effect waves-light " + (this.state.loading ? 'disabled' : ' ')}   onClick={this.getFbUser} >Ingresar con Facebook</a>
             <a className={"btn btn-inverse waves-effect waves-light " + (this.state.loading ? 'disabled' : ' ')}  onClick={this.openSignupForm} >Ingresar con Número celular</a>

          <form className="loginForm">
            <h4>Ingresa con tu email</h4>
            {this.state.error !== '' &&
            <p className="error center animated shake">{this.state.error}</p>
            }

               <input type="text"  value={this.state.username} placeholder="Email" onChange={this.setEmail} />
               <input type="password" value={this.state.password} placeholder="Contraseña" onChange={this.setPassword} />


              <a name="button" onClick={this.loginEmail} className={"btn waves-effect waves-light btn-orange " + (this.state.loading ? 'disabled' : ' ')}  >Ingresar</a>

            <a className="center text">¿Olvidaste tu contraseña?</a>
          </form>

      </div>

    }

        { this.state.loginNum  &&
           <VerifyPhone verified={this.handleVerification.bind(this)}/>
        }
        </div>

    );
  }
}


export default Login;



// WEBPACK FOOTER //
// ./src/components/auth/login/Login.js